/**
 * Simple pub/sub event system for Smart lifecycle hooks.
 *
 * Usage:
 *   Smart.on('before:init', (config) => { ... })
 *   Smart.emit('before:init', config)
 *   Smart.off('before:init', handler)
 */

const listeners = {};

export function on(event, handler) {
    if (!listeners[event]) {
        listeners[event] = [];
    }
    listeners[event].push(handler);
}

export function off(event, handler) {
    if (!listeners[event]) return;
    listeners[event] = listeners[event].filter(h => h !== handler);
}

export function emit(event, data) {
    if (!listeners[event]) return;
    listeners[event].forEach(handler => {
        try {
            handler(data);
        } catch (e) {
            console.error(`[Smart] Error in event handler for '${event}':`, e);
        }
    });
}

export default { on, off, emit };
